export const SET_PROFILE_STATE = 'profile/SET_STATE';
export const REQUEST_FETCH_PROFILE = 'client/REQUEST_FETCH_PROFILE';
export const REQUEST_UPDATE_USER = 'profile/REQUEST_UPDATE_USER';
export const REQUEST_UPDATE_SETTINGS = 'profile/REQUEST_UPDATE_SETTINGS';
export const REQUEST_MARK_TUTOTIAL_STEPS_COMPLITE = 'profile/REQUEST_MARK_TUTOTIAL_STEPS_COMPLITE';
export const REQUEST_CONNECT_PROVIDER = 'profile/REQUEST_CONNECT_PROVIDER';
export const REQUEST_DASHBOARDS = 'profile/REQUEST_DASHBOARDS';
export const REQUEST_USER_NAMESPACE = 'profile/REQUEST_USER_NAMESPACE';
export const REQUEST_FETCH_PRO_SUCCESS = 'profile/REQUEST_FETCH_PRO_SUCCESS';
